function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { stringify } from 'query-string';
import { HttpClient } from 'api/http-client';
export var NoteSourceType = /*#__PURE__*/ function(NoteSourceType) {
    NoteSourceType["Company"] = "COMPANY";
    NoteSourceType["Project"] = "PROJECT";
    NoteSourceType["ExpenseReject"] = "EXPENSE_REJECT";
    NoteSourceType["ExpenseReportReject"] = "EXPENSE_REPORT_REJECT";
    return NoteSourceType;
}({});
export var NoteSubType = /*#__PURE__*/ function(NoteSubType) {
    NoteSubType["ProjectReject"] = "PROJECT_REJECT";
    NoteSubType["WorkReject"] = "WORK_REJECT";
    NoteSubType["OverallReject"] = "OVERALL_REJECT";
    NoteSubType["CompanyField"] = "COMPANY_FIELD";
    NoteSubType["ProjectField"] = "PROJECT_FIELD";
    NoteSubType["ExpenseReject"] = "EXPENSE_REJECT";
    return NoteSubType;
}({});
class NoteHttpClient extends HttpClient {
    constructor(...args){
        super(...args), _define_property(this, "getAllNotesBySource", async (source)=>this.get(`/notes?${stringify(source)}`)), _define_property(this, "createNote", async (payload)=>this.post('/notes', payload)), _define_property(this, "updateNote", async (payload)=>this.put(`/notes/${payload.note.noteId}`, payload)), _define_property(this, "deleteNote", async (noteId)=>this.delete(`/notes/${noteId}`)), /** Project Note Endpoints */ _define_property(this, "getAllProjectNotes", async (source)=>this.get(`/notes/projects/${source.sourceId}?${stringify(source)}`)), _define_property(this, "createProjectNote", async (payload)=>this.post(`/notes/projects/${payload.associatedEntity.sourceId}`, payload)), _define_property(this, "updateProjectNote", async (payload, sourceType, sourceId)=>this.put(`/notes/${payload.note.noteId}/projects/${sourceId}/`, payload)), _define_property(this, "deleteProjectNote", async (noteId, sourceType, sourceId)=>this.delete(`/notes/${noteId}/projects/${sourceId}`));
    }
}
export const NoteAPI = new NoteHttpClient();
